import { mrinsOnVendor, retrieveAttachment, viewSampleRequest } from "../apis";

export const routes = {
  //Packaging-GIN Release Routes://New packing APIs
  quoteItemsInfo: "packing-getQuoteLineCreationInfo",
  insertQuoteItem: "packing-insertQuoteLineItemDetail",
  getAllPackingRequests: "packing-getAllPackingRequests",
  viewPackingRequest: "packing-viewPackingRequest",
  requestNewPackType: "packing-requestNewPackType",
  approveNewPackType: "packing-approveNewPackType",
  rejectNewPackType: "packing-rejectNewPackType",
  //Sample Management Api routes
  listMasterSamples: "mastersample/all",
  listAlternativeSamples: "alternativesample/all",
  alterSampleByMasterSampleId: "altsample-by-mastersampleid",
  customerSampleByMasterSampleId: "customersamples",
  masterSampleDetails: "mastersample",
  masterSampleOptions: "sample/options",
  masterSampleItemDetails: "sample/items",
  masterSampleParameters: "sample/parameters",
  masterSample: "mastersample",
  masterSampleCode: "mastersample/generatecode",
  alternativeSampleCode: "alternativesample/generatecode",
  alternateSample: "altsamples",
  alternativeSample: "alternativesample",
  customerSampleDetails: "customersample",
  customerSample: "customersamples",
  customerSampleInfo: "sample/customers",
  customerSampleList: "customersample/all",
  customerAltSampleList: "customersample",
  alternativeSampleList: "altsamples",
  packingTypes: "sample/packingtypes",
  createAttachments: "create-attachments",
  retrieveAttachments: "retrieve-attachments",
  retrieveNotes: "retrieve-notes",
  createNotes: "create-notes",
  createAuditLogs: "create-auditlogs",
  retrieveAuditLogs: "retrieve-auditlogs",
  //--------
  login: "login",
  //login: "testenvLogin",
  forget: "dev-forgotPassword",
  forgotPassword: "forgot",
  confirmForgotPassword: "confirm",
  registerUser: "dev-userRegistration",
  insertUser: "dev-insertUserDetails",
  // Crdev-eatedUser:"createdSupplier",
  listPoolUsers: "dev-listPoolUsers",
  // usdev-erStatus: "userStatus",
  userStatus: "enable",
  userStatusDisable: "disable",
  changePassword: "change",
  // ledev-ads: "getAllLeads",

  accounts: "getAllAccounts",
  contacts: "getAllContacts",
  quotes: "getAllQuotes",
  grid: "grid",
  userAllDetail: "dev-getAllUsersDetail",
  division: "users/division",
  country: "getCountry",
  state: "getState",
  city: "getCity",
  getuserInfo: "getuserInfo",

  updateUserLoginHistory: "history-login",
  getUserLoginHistory: "history-login/:id",
  checkInvoiceNumberExists: "check-invoice-number-exists",

  convertLeadToAccount: "insertLeadIntoAccount",
  getUsers: "getUsers",
  quotesInfo: "dev-getQuotationCreationInfo",
  insertQuote: "dev-insertQuotationDetail",
  sampleRequests: "getAllSampleRequests",
  accountsDetail: "getAccountHyperlink",
  getAccountPriceinfo: "getAccountPriceinfo",
  accountContact: "cvuAccountContactDetails",
  accountSample: "dev-cvuSampleRequest",
  insertSample: "insertOrUpdateSampleRequest",
  viewSample: "viewSampleRequest",
  getQuoteItems: "dev-getAllQuoteLineItems",
  updateQuoteItem: "dev-updateQuoteLineInfo",
  updateQuoteStatus: "dev-updateQuotationStatus",
  getAccountContacts: "getAccountContacts",
  getAccountSamples: "getAccountSamples",
  getAccountQuotes: "getAccountQuotes",
  reassignLead: "dev-reassignLead",
  reassignAccount: "reassignAccount",
  quotesInfoErp: "getQuoteInformation",
  quoteItemSystemInfo: "dev-qqiSystemMasterInfo",
  quoteItemSystemPackInfo: "dev-qqiSamplePackDetails",
  quoteRequestPrice: "dev-quotationPriceRequest",
  quoteSamples: "dev-qqiSampleGCConfig",
  quoteSamplePricing: "dev-updateQuotePricingInfo",
  quoteRequestGCRates: "dev-reqForGcRates",
  currencyConversion: "dev-qqiCurrencyStamp",

  filterFixedContracts: "filterFixedContracts",
  filterFixedContractsCustom: "filterFixedContractsCustom",
  getFixedContractsByFields: "getFixedContractsByFields",

  approvedQuotesOnGC: "dev-listApprovedQtLinesOnGc",

  getProductAndCategory: "getcreateSRItemForm",
  createVendor: "dev-insertVendorGCPO",
  //order
  getQuoteLineItemsByQuote: "order/quote",
  getOrders: "order",
  getOrdersLineItem: "order/lines",
  getOrderLineItem: "order/line",
  createOrder: "order/create",
  updateOrder: "order/order",
  updateOrderLineItem: "order/orderline",
  updateOrderDispatch: "order/dispatch",
  getOrdersDispatch: "order/dispatches",
  getOrderDispatchPPCPlanning: "order/dispatches/ppcplanning",
  getOrderDispatch: "order/dispatch",
  getOrderDispatchPackingUnits: "order/dispatch/packingunits",
  getOrderDispatchesByOrder: "order/dispatches/order",
  documentsForDispatch: "order/document",
  downloadDocumentForDispatch: "order/document/download",
 
  //mridev-n
  getAllmrins: "listMrins",
  mrinDetails: "dev-viewMrin",
  submitMRINToQC: "submitMRINToQC",
  createOrUpdateMrin: "dev-insertOrUpdateMrin",
  editMrinInformation: "editMrinInformation",
  CloseButton: "closeButton",
  approveMRINByAccounts: "approveMRINByAccounts",
  approveMRINByQC: "approveMRINByQC",
  // mrdev-in list for po
  getMrinListForPoView: "dev-getMrinListForPoView",
  // Gcdev-s
  getGCs: "listGCDetails",
  fixedContracts: "fixedContracts",
  editFixedContracts: "editFixedContracts",
  getGCDetail: "viewGCDetail",
  // Sudev-pplier
  getSuppliers: "dev-getSuppliers",
  getSupplierList: "listSuppliers",
  editSuppliers: "dev-editSupplier",
  curdSupplier: "supplier",
  createSupplier: "create",
  updateSupplier: "update",

  vendorLogin: "dev-vendorLogin",

  getGCDebitNoteCreationInfo: "dev-getGCDebitNoteCreationInfo",
  listGCDebitNoteDetails: "listGCDebitNoteDetails",
  createDebitNote: "debitnote",
  updateDebitNote: "debitnote/update",
  updateDebitNoteStatus: "debitnote/updateDebitNoteStatus",
  viewGCDebitNoteDetail: "dev-viewGCDebitNoteDetail",
  createorupdateSampleLineItem: "insertOrUpdateSampleLineItem",
  getNotifications: "getNotifications",
  postNotifications: "notification",
  viewAndDeleteSampleLineItem: "viewAndDeleteSampleLineItem",

  updateMRINGCSpec: "dev-updateMRINGCSpec",
  sendEmail: "dev-sendITSupportEmail",
  noReplyMail: "sendSystemNoReplyEmail",
  releaseDebitNote: "releaseDebitNote",
  taxMaster: "dev-cvu_Tax_Master",
  taxList: "dev-list_Tax_Grid",

  getbillingaddress: "getbillingaddress",
  getshippingaddress: "getshippingaddress",

  getConversatioRatio: "getConversatioRatio",
  getSamplesInfo: "getSamplesInfo",
  getSelectedSamplesForPricing: "getSelectedSamplesForPricing",
  updateQuotationStatusForPricing: "updateQuotationStatusForPricing",
  updateGcPriceOnQuotes: "updateGcPriceOnQuotes",
  getOtherFactorsInfo: "getOtherFactorsInfo",
  updateOtherFactorsInfo: "updateOtherFactorsInfo",
  updateSamplesInfoForPricing: "updateSamplesInfoForPricing",
  getPackingInfoForPricing: "getPackingInfoForPricing",
  getFinalisedSamples: "getFinalisedSamples",
  updateConfirmSample: "updateConfirmSample",
  insertPricingInfo: "insertPricingInfo",
  getGCDataOnQuotes: "getGCDataOnQuotes",
  getSupplierGroups: "getSupplierGroups",

  getNewPackingRequests: "packing-getNewPackingRequests",
  createNewPackingType: "packing-createNewPackingType",
  getNewPackTypeCreationInfo: "packing-getNewPackTypeCreationInfo",
  viewNewPackingType: "packing-viewNewPackingType",
  updateNewPackingType: "packing-updateNewPackingType",
  // getBlendSheetList: "blendsheet/all",
  getBlendSheetView: "gcblendsheet/view",
  getBlendSheetUpdate: "gcblendsheet/update",
  getBlendSheetCreate: "gcblendsheet/create",
  getBatchNumber: "blendsheet/batchnumber",
  blendSheet: "blendsheet",
  getNotesAttachments :"notes-attachments/netsuite",
};

export const Cclmodule = {
  purchaseOrder: "po",
  MRIN: "mrin",
  quote: "quote",
  debitnote: "debitnote",
  users: "users",
  auth: "auth",
  blendsheet: "blendsheet",
  gcblendsheet: "gcblendsheet",
  order: "order",
  leads: "leads",
  vendor: "vendor",
  logisticCosts: "logistic-costs",
  gc: "gcitem",
  account: "account",
  packing: "packing",
  certification: "certification",
  notification: "notification",
  samples: "samples",
  taxes: "taxes",
  gcallocationgrid: "gc-allocation",
  reports: "reports",
  gcinventory:"gc-inventory",
  samplerequest:"sample-request",
  gcdailyrate:"gc-daily-rates",
  gcenquiry:"gc-enquiry",
  auditreport:"audit-reports",
  InputCostRequestedGC:'InputCostRequestedGC',
  status:'status',
  quotation:"quotation",
  pricing:"pricing",
  qlireport:"qli-reports",
  attachment:"notes-attachments",
  finishedGood : "finished-good",
  quotationDomestic : "quotation-domestic",
};

export const apiRoutes = {
  // po
  common: "common",
  destinationPortsList: "get-destination-ports-list",
  getforminfo: "forminfo",
  getcreationinfo: "creationinfo",
  getcreate: "create",
  getdetails: "details",
  getdispatchdetails: "dispatch",
  getlinedetails: "line",
  getorderdetails: "order",
  updateGCPODetails: "update",
  getpoDocumentsUpload: "documents",
  getpoDocumentsDownload: "download",
  getDocumentDownload:"notes-attachments/attachments",
  getUploadDocuments:"notes-attachments/upload-attachment",
  portAndOriginForPo: "portandorigin",
  getBalQuote: "quotation",
  getupdateGcPoStatus: "status",
  gettop3ApprovedPo: "top3approved",
  gettopmrin: "topmrin",
  getaddothercharges: "charges",
  getupdatePrice: "price",
  schedules: "schedules",
  validate:'validate',
  schedule: "schedule",
  calendar: "calendar",
  item: "item",
  alternateSamples: "alternate-sample",
  customersamples: "customer-sample",
  mastersamples: "master-sample",
  plantcapacity: "plantcapacity",
  accountwithcustomersamplewithoutquote:
    "accounts-with-customer-sample-without-quotes",
  accountwithquotewithoutcustomersample:
    "accounts-with-quotes-without-customer-sample",
  inactiveaccount: "inactive-accounts",
  creategcinventory:'create-gc-inventory',
  getgcinventory:'item-wise',
  getgcinventoryquote:'item-wise-quotes',
  // mrin
  po: "PO",
  dispatchMRIN: "Dispatch",
  getmrinlist: "getmrinlist",
  otherSpecification: "otherSpecification",
  gettopmrindetails: "topMrinDetails",
  view: "View",
  View: "view",
  payment: "payment",
  document: "document",
  refreshtoken:"refresh-token",

  // quote
  billingonly: "billing",
  address: "address",
  shippingonly: "shipping",
  currencies: "currencies",
  incoterms: "incoterms",
  account: "account",
  quotation: "quotation",
  sample: "sample",
  line: "line",
  reject: "reject",
  md: "MD",
  clone: "clone",
  ports: "ports",
  destination: "destination",
  loading: "loading",
  statuses: "statuses",
  approved: "approved",
  packing: "packing",
  categories: "categories",
  quoteline: "quoteline",
  update: "update",
  info: "info",
  approvedlist: "approvedlist",
  approvedGcPrice:"approved-gc-price",
  activefinancialyears : "active-financial-years",
  quarterlist : "quarter-list",
  sampleaccount: "sample-account-information",
  accountquotation: "account-information",

  //  debit note
  getGCDebitNoteCreationinfo: "getGCDebitNoteCreationInfo",
  getmrinonvendor: "getMrinOnVendors",
  updateDebitNoteStatus: "updateDebitNoteStatus",
  getallpackingsubtypes: "getallpackingsubtype",
  getallpackingtypes : "packing-name-list",
  quoteview: "quote-view",
  quotequantityitem: "get-quote-quantity-item",
  poview: "po-view",

  // users
  forminfo: "forminfo",
  detailsId: "details",
  update: "update",
  password: "password",
  create: "create",
  //belndsheet

  process: "process-netsuite",

  //    leads
  list: "list",
  contacts: "contacts",
  info: "info",
  accounts: "accounts",
  codes: "codes",
  coffee: "coffee",
  countries: "countries",
  products: "products",
  salutation: "salutation",
  update: "update",
  reassign: "reassign",

  // vendor
  details: "details",
  detail: "detail",
  list: "list",
  allpo: "allpo",
  dispatch: "dispatch",
  info: "info",
  update: "update",
  //  gc
  frominfo: "frominfo",
  update: "update",
  gcUOMList: "gc-uom-list",
  // account
  pricing: "pricing",
  contact: "contact",
  list: "list",
  reassigng: "re-assign",
  quotes: "quotes",
  lead: "lead",
  approve: "approve-convert-reject",
  pricing: "pricing",
  shipping: "shipping-address",
  details: "details",
  itempodetails:"item-po-details",
  itemmrindetails:"item-mrin-details",
  supplierpodetails:"supplier-po-details",
  suppliermrindetails:"supplier-mrin-details",
  billing: "billing-address",
  update: "update",
  info: "info",
  accountgrid:"account-grid",
  // packing
  listnaturalpoly: "listnaturalpoly",

  // certifications
  form: "form",
  body: "body",
  grid: "grid",

  // productioncost
  productioncost: "productioncost",
  otherfactors: "otherfactors",
  Production: "Production",
  OtherFactorsInfo: "updateProductionOtherFactorsInfo",

  gridgcallocation: "grid-gcallocation",
  updategcallocation: "updategc-allocation",
  createallocation: "creategc-allocation",
  samplereport: "sample-report",
  itemview: "item-view",
  dispatchgrid: "dispatchgrid",
  allocatedpoqty: "allocatedpoquantity",
  customersamplegride: "customer-sample-grid",
  neededgride: "needed-grid",
  syncnetsuite:"syncnetsuite",
  bominfo:"bom-info",
  createsamplerequest:"create-sample-request",
  SampleRequestview:"view-sample-request",
  samplerequeststatus:"sample-request-status",
  updatesamplerequest :"update-sample-request",
  gridsampleline:"grid-smaple-line",
  listofvalues:"list-of-values",
  SamplelineRequestview:"view-sample-line",
  createsampleline:"create-sample-line",
  updatesampleline :"update-sample-line",
  updatesamplelinerd :"update-sample-line-rd",
  statusupdate:"status-update",
  customerfeedback:"view-sample-line-customer-feedback",
  quotebom:"update-bom-info",
  gridgcrates:"grid-gc-daily-rates",
  creategcrates:"create-gc-daily-rates",
  convertionrate:"getconversionrate",
  viewgcdailyrates:"view-gc-daily-rates",
  gcdailyratedbyitem:"list-by-item",
  updategcdailyrates:"update-gc-daily-rates",
   gcenquirygrid:"gird-gc-enquiry",
   gcenquirygriditem:"view-gc-enquiry-by-itemid",
   listvendor:"list-vendors",
   listitem:"list-items",
   gcdailyrateitemlist:"list-gc-daily-items",
   creategcenquiry:"create-gc-enquiry",
   viewgcenquiry:"view-gc-enquiry",
   updategcenquiry:"update-gc-enquiry",
   gcinformation:"gc-information",
   viewpicklist:"view-pick-list",
   batchoutput:"batch-output",
   getBatchOutput:"/view",
   listBatchOutputs:"/list-batch-output",
   listAlternativeSampleBatchOutputs:"/list-as-batch-output",
   listCustomerSampleBatchOutputs:"/list-account-batch-output",
   GetAllAlternativeSamples:"/list-all-alternativesamples",
   alternativeSampleDetails:"/get-alternative-sample-details",
   createBatchOutput:"/create",
   updateBatchOutput:"/update",
   quotestatus:"quote-status",
   quotegrid:"quote-grid",
   createquote:"create-quote",
   viewquote:"view-quote",
   createquoteneline:"create-quote-line",
   viewquotationline:"view-quote-line",
   quotelinegrid:"quote-line-grid",
   updatequotestatus:"update-quote-status",

   getfinalizedsampleinfo:"getfinalizedsampleinfo",
   updatefinalizedsample:"updatefinalizedsample",
  getgcdataonquotes:"getgcdataonquotes",
  getotherfactorsinfo:"getotherfactorsinfo",
  getpackinginfopricing:"getpackinginfopricing",
  getsamplesinfo:"getsamplesinfo",
  insertpricinginfo:"insertpricinginfo",
  selectedsampleprincinginfo:"getselectedsamplepricing",
  updateconfirmedsample:"updateconfirmedsample",
  updategcprice:"updategcprice",
  updateotherfactors:"updateotherfactors",
  updateproductionotherfactors:"updateproductionotherfactors",
  updatestatuslog:"updatestatuslog",
  updatequotepricingstatus:"update-quote-pricing-status",
  lineupdateinfo:"line-update-info",
  requestrepricing:"request-repricing",
  updatequotationline:"update-quote-line",
  quotationupdate:"update-quote",

  gcinformation:"gc-information",
  viewpicklist:"view-pick-list",

  batchoutput:"batch-output",
  getBatchOutput:"/view",
  listBatchOutputs:"/list-batch-output",
  listAlternativeSampleBatchOutputs:"/list-as-batch-output",
  listCustomerSampleBatchOutputs:"/list-account-batch-output",
  GetAllAlternativeSamples:"/list-all-alternativesamples",
  GetAllBlendSheets:"/list-all-blendsheets",
  getWorkOrderInfo: "gcblendsheet/workorder-info",
  getBlendBatchOutputs:"/list-blend-batch-output",
  getOrderDispatchData:"/list-order-dispatch",
  alternativeSampleDetails:"/get-alternative-sample-details",
  createBatchOutput:"/create",
  updateBatchOutput:"/update",

  usertotp:"users-totp",
  totverify:"users-totverify",
  refresh:"refresh",
  logout:"logout",
  logoutDevice:"logout-device",

  // Customer sample
customerSample:"customer_sample/create",
editCustomerSample:"customer_sample/update",
viewCustomerSample:"customer_sample/view",
sampleOptions:"customer_sample/options",
sampleItems:"customer_sample/items",
sampleParameters:"customer_sample/parameters",
customersampleinfo:"customer_sample/customers",

  createnote:"create-notes",
  retrivenote:"retrive-notes",
  createAttachment:"create-attachments",
  auditlog:"create-auditlog",
  retrieveAttachment:"retrive-attachments",
  retrieveAuditlog:"retrive-auditlogs",
  categoryList: "category-list",
  gcItemList : "gc-item-list",
  getAromasList : "samples/get-aroma-list",
  PCList : "samples/get-product-category-list",
  productFlavourList : "samples/get-product-flavor-list",
  productSubTypeList : "samples/get-product-sub-type-list",
  productList : "samples/get-product-list",
  parametersList : "samples/get-parameters-list",
  deleteCSParameter : "samples/delete-customer-sample-parameters",
  pickList : "pick-list",
  factoryCode : "factory-code-list",
  order : "order",
  dispatch : "dispatch",
  packingunits : "packingunits",
  entityList : "entity-list",
  gcItemTypeList: "gc-item-type-list",
  PO: "po",
  getTaxList: "get-taxes-list"
};

